import { render, staticRenderFns } from "./TemplateOverViewWorkflowComponent.vue?vue&type=template&id=244bde8e&scoped=true&"
import script from "./TemplateOverViewWorkflowComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateOverViewWorkflowComponent.vue?vue&type=script&lang=js&"
import style0 from "./TemplateOverViewWorkflowComponent.vue?vue&type=style&index=0&id=244bde8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244bde8e",
  null
  
)

export default component.exports